const LAZY_UNINITIALIZED = -1
const LAZY_PENDING = 0

/**
 * Starts loading a React.lazy() component chunk without mounting it.
 * @param {import('react').LazyExoticComponent} LazyComponent
 */
export const preloadLazyComponent = (LazyComponent) => {
  const payload = LazyComponent?._payload

  if (!payload) {
    return Promise.resolve()
  }

  if (payload._status === LAZY_UNINITIALIZED && typeof payload._result === 'function') {
    return Promise.resolve(payload._result())
  }

  if (payload._status === LAZY_PENDING) {
    return Promise.resolve(payload._result)
  }

  return Promise.resolve()
}
